import { createFileRoute } from '@tanstack/react-router';
import { filtrosDaBusca, lerBuscaVerNaTela } from '@/relatorios/ver-na-tela';
import { RelatorioJanela } from '@/relatorios/relatorio-janela';

/** Janela "Ver na tela" (S36-D4): /relatorio?rel=<id>&<filtros>. A busca vem da URL; o relatorio e gerado de novo nesta janela. */
export const Route = createFileRoute('/_app/relatorio')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaVerNaTela(bruto),
  component: RelatorioRota,
});

function RelatorioRota() {
  const busca = Route.useSearch();
  return <RelatorioJanela id={busca.rel} params={filtrosDaBusca(busca)} />;
}
